import { ObservableMap } from 'mobx';
import { getGlobalSettingsAccount } from 'owa-account-source-list-store';
import { markFunction } from 'owa-performance';
import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import { convertOwaUserConfigurationToSessionStore } from '../utils/convertOwaUserConfigurationToSessionStore';
import { setOwaSessionStoreInternal } from './setOwaSessionStoreInternal';
import { userConfigurationSet } from './userConfigurationSet';

const setConnectedAccountsUserConfig = mutatorAction(
    'setConnectedAccountsUserConfig',
    (userConfig: OwaUserConfiguration, mailboxId: string) => {
        const store = getStore();
        if (!store.connectedAccountsUserConfigurationMap) {
            store.connectedAccountsUserConfigurationMap = new ObservableMap({});
        }
        store.connectedAccountsUserConfigurationMap.set(mailboxId, userConfig || {});
    }
);

export default markFunction((userConfiguration: OwaUserConfiguration, mailboxId?: string): void => {
    if (!mailboxId) {
        const sessionStore = convertOwaUserConfigurationToSessionStore(
            getGlobalSettingsAccount().sourceId,
            userConfiguration
        );
        setOwaSessionStoreInternal(sessionStore);
        userConfigurationSet(sessionStore.userConfiguration);
    } else {
        setConnectedAccountsUserConfig(userConfiguration, mailboxId);
        userConfigurationSet(userConfiguration, mailboxId);
    }
}, 'uc');
